import React from "react";
import { useIncrementSnapper } from "../../../../../hooks/inputIncrement";
import { FIELD_NAMES } from "../../../../../constants/commonConstants";
import { MoneyInput } from "./moneyInput";
import PropTypes from "prop-types";

export const LoanAmountInput = (props) => {
  const {
    productType,
    title,
    decimalPlaces,
    fieldName,
    minLoanAmount
  } = props;
  const fieldNameValue = fieldName ? fieldName : FIELD_NAMES.LOAN_AMOUNT;
  const [ref, onBlur] = useIncrementSnapper(fieldNameValue, productType, minLoanAmount);

  return (
    <MoneyInput
      ref={ref}
      onBlur={onBlur}
      name={fieldNameValue}
      title={title || "Enter your loan amount"}
      decimalPlaces={decimalPlaces}
    />
  );
};

LoanAmountInput.propTypes = {
  productType: PropTypes.string,
  title: PropTypes.string,
  decimalPlaces: PropTypes.number,
  fieldName: PropTypes.string,
  minLoanAmount:  PropTypes.number,
}